import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-oauth-callback',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './oauth-callback.component.html',
  styleUrl: './oauth-callback.component.scss'
})
export class OAuthCallbackComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('session_state');
    console.log('code', code)
    console.log('state', state);

    if (code && state) {
      // 'http://localhost:4200/'
      let appUrl = environment.development ? 'https://dev.designeriframe.se2.tech/' : environment.staging ? 'https://stage.designeriframe.se2.tech/' : 'https://designeriframe.se2.tech/';
      // let appUrl = 'http://localhost:4200/';
      this.authService.requestToken(appUrl, state, code)
        .subscribe(
          (token:string) => {
            localStorage.setItem('token', token);
            if (window.opener) {
              window.opener.postMessage({ type: 'SOCIAL_LOGIN_SUCCESS', token }, '*');
            }
            window.close();
          },
          (err:any) => {
            console.error('Token request failed', err);
            window.close(); 
          }
        );
    } else {
      console.warn('Missing code or session_state in URL');
      window.close();
    }
  }
}
